import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper, Content } from './styles.js'

import Container from '@atoms/Container'

const CTA = ({ bgColor, center, children }) => {
  return (
    <Wrapper bgColor={bgColor}>
      <Container>
        <Content center={center}>{children}</Content>
      </Container>
    </Wrapper>
  )
}

CTA.propTypes = {
  bgColor: PropTypes.string,
  center: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

CTA.defaultProps = {
  bgColor: 'white',
  center: false,
  children: null,
}

export default CTA
